/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @description
 *
 * @created at 2024-11-14 15:15:50
 **/

import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { ZIndex } from "@/frameworks/core/commons";

import { Row } from "../../../Layouts";

interface TooltipInterface {
	zIndex?: number;
}

// Tip.tsx
export const TipWrap = styled(Row)`
	position: relative;
	background-color: ${({ theme }) => `${theme.colors.neutral_00_100}`};
	border-radius: 8px;
	box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.08);
	padding: 8px;
`;

export const TextWrap = styled(Row)`
	padding: 2px 4px 2px 2px;
`;

export const calMaxWidth = (maxWidth: number) => {
	return css`
		box-sizing: border-box;
		max-width: ${maxWidth}px;
	`;
};

// Tooltip.tsx

export const IconWrap = styled(Row)``;

export const Content = styled.div<TooltipInterface>`
	z-index: ${(props) => (props.zIndex ? props.zIndex : ZIndex.POPUP)};
	background-color: ${({ theme }) => theme.colors.neutral_00_100};
	border-radius: 8px;
	padding: 8px 12px;
	box-shadow:
		0px 8px 16px 0px rgba(0, 0, 0, 0.2),
		0px 0px 4px 0px rgba(0, 0, 0, 0.04);
`;

export const Message = styled.div`
	padding: 2px 0px;
`;
